import { useState, useContext, useRef } from "react";
import { useNavigate, useParams } from "react-router";
import t from "../locales";
import Button from "../components/button";
import fetchPosts from "../helpers/fetch_helper";
import CATEGORIES from "../data/categories";
import { PostsContext } from "../app";

export default function Dashboard() {
  const { category: categoryKey } = useParams();
  const category = CATEGORIES[categoryKey];
  const groupCodeRef = useRef(null);
  const [error, setError] = useState("");
  const { setPosts } = useContext(PostsContext);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const queryValue = groupCodeRef.current?.value.trim();

    if (!queryValue) return;

    setError("");
    const fetchedPosts = await fetchPosts(queryValue, category);

    if (!fetchedPosts) {
      setError(t("dashboard.error.other"));
      return;
    } else if (fetchedPosts.length === 0) {
      setError(t("dashboard.error.empty"));
      return;
    }

    setPosts(fetchedPosts);
    navigate(`/${categoryKey}/dashboard/${encodeURIComponent(queryValue)}`);
  };

  if (category === undefined) {
    return (
      <p className="dashboard__error">{t("dashboard.error.unavailable")}</p>
    );
  }

  return (
    <>
      <title>{t("dashboard.title")}</title>
      <div className="dashboard">
        <div className="dashboard__header">
          <h1 className="dashboard__title">{category.dashboard.heading}</h1>
          <p className="dashboard__subtitle">
            {category.dashboard.description}
          </p>
        </div>
        <form onSubmit={handleSubmit} className="dashboard__form">
          <input
            type="text"
            ref={groupCodeRef}
            placeholder={t("dashboard.input.placeholder")}
            className="dashboard__input"
          />
          {error && <p className="dashboard__error">{error}</p>}
          <Button type="submit" label={t("dashboard.submit")} />
        </form>
      </div>
    </>
  );
}
